// Fixed English labels keep prerendered HTML and browser hydration identical.
// The list preserves the existing ISO 3166-1 options and site naming choices.
import labels from './countries.json'
export const countries = labels
